import { useLayoutEffect, useRef } from "react";
import SignInForm from "../components/auth/SignInForm";

// The sign-in card is laid out at this width and scaled to the width of the Charizard slab in the
// banner, so it takes that slab's place. Keep in step with .sign-in-banner__card in index.css.
const SLAB_CARD_WIDTH = 260;

// The whole PCG banner, with the sign-in card standing in for the middle (Charizard) slab. Screens
// too small for a readable card at slab size get the banner with the card beside or below it.
function SignInView() {
  const slabRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const slab = slabRef.current;
    if (!slab || typeof ResizeObserver === "undefined") return;
    const fit = () =>
      slab.style.setProperty("--slab-scale", String(slab.clientWidth / SLAB_CARD_WIDTH));
    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(slab);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="sign-in-banner">
      <div className="sign-in-banner__backdrop" aria-hidden="true" />
      <div className="sign-in-banner__stage">
        <div className="sign-in-banner__art" aria-hidden="true" />
        <div className="sign-in-banner__slab" ref={slabRef}>
          <div className="sign-in-banner__card">
            <SignInForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignInView;
